import { EquipMain } from "../equipmentType";
import { equipsGrade0 } from "./grade0";
import { equipsGrade1 } from "./grade1";
import { equipsGrade2 } from "./grade2";
import { equipsGrade3 } from "./grade3";
import { equipsGrade4 } from "./grade4";
import { equipsGrade5 } from "./grade5";
import { equipsGrade6 } from "./grade6";

const equipPool = {
  equipsGrade0: equipsGrade0,
  equipsGrade1: equipsGrade1,
  equipsGrade2: equipsGrade2,
  equipsGrade3: equipsGrade3,
  equipsGrade4: equipsGrade4,
  equipsGrade5: equipsGrade5,
  equipsGrade6: equipsGrade6
};
const equipPoolList: EquipMain[] = Object.values(equipPool).reduce((a, b) =>
  a.concat(b)
);
export { equipPool, equipPoolList };
